import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import {
  OCC_USER_ID_ANONYMOUS,
  RoutingService,
  SemanticPathService,
  UserIdService
} from '@spartacus/core';
import { LaunchDialogService } from '@spartacus/storefront';
import { Observable, Subscription, combineLatest, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CustomMultiCartService } from '../../../core/src/cart/facade/custom-multi-cart.service';
import { CustomCheckoutService } from '../../../core/src/checkout/facade/custom-checkout.service';
import { CustomUserOrderService } from '../../../core/user/facade/order/custom-user-order.service';

@Injectable({
  providedIn: 'root',
})
export class CustomOrderConfirmationGuard implements OnDestroy {
  private subscriptions: Subscription = new Subscription();
  userId: string;

  constructor(
    private checkoutService: CustomCheckoutService,
    private router: Router,
    protected routingService?: RoutingService,
    protected launchDialogService?: LaunchDialogService,
    private semanticPathService?: SemanticPathService,
    private userOrderService?: CustomUserOrderService,
    protected multiCartService?: CustomMultiCartService,
    protected userIdService?: UserIdService
  ) { }

  canActivate(activatedRoute: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    this.subscriptions.add(
      combineLatest([
        this.checkoutService.getPaypalOrderSuccess(),
        this.checkoutService.getPaypalOrderError(),
      ]).subscribe(([paypalOrderSuccess, paypalOrderError
      ]) => {

        if (paypalOrderSuccess) {
          this.onPayPalOrderCreatingSuccess(true);
        }
        if (paypalOrderError) {
          this.routingService.go('/checkout/shipping-address');
        }
      }));
    const orderCode = activatedRoute.url[1]?.path;
    if (orderCode) {
      if (activatedRoute.queryParams?.paymentId) {
        this.multiCartService.setActiveCartIdEmpty();
        this.createPaypalOrder(orderCode);
      } else {
        this.multiCartService.setActiveCartIdEmpty();
        this.userOrderService.loadOrderDetails(orderCode);
      }
      return of(true);
    } else {
      return this.checkoutService.getOrderDetails().pipe(
        map((orderDetails) => {
          if (orderDetails && Object.keys(orderDetails).length !== 0) {
            return true;
          } else {
            return this.redirectToOrdersPage();
          }
        })
      );
    }
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  private redirectToOrdersPage(): UrlTree {
    return this.router.parseUrl(this.semanticPathService.get('orders'));
  }

  protected createPaypalOrder(orderCode: string): void {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.checkoutService.createPaypalOrder(urlParams.get('paymentId'), urlParams.get('token'), urlParams.get('PayerID'), orderCode);
  }

  protected onPayPalOrderCreatingSuccess(isSuccess: boolean): void {
    this.subscriptions.add(this.userIdService.getUserId().subscribe((userId) => {
      this.userId = userId;
    }));
    if (isSuccess) {
      this.subscriptions.add(this.checkoutService.getPaypalOrderState().subscribe(state => {
        const paypalOrder: any = state.value;
        if (paypalOrder) {
          this.userOrderService.loadOrderDetails(this.userId !== OCC_USER_ID_ANONYMOUS ? paypalOrder.code : paypalOrder.guid);
        }
      }));
    }
  }
}
